import { ref } from 'vue';
import { resolveIsChinaMainlandUser } from '@/utils/china-mainland-region';

/** App 壳挂载的地区限制弹窗可见性 */
export const chinaRegionUnsupportedOpen = ref(false);

/** @type {((allowed: false) => void) | null} */
let pendingResolve = null;

/**
 * 打开地区限制弹窗；关闭后 resolve(false)。
 * @returns {Promise<false>}
 */
export function openChinaRegionUnsupportedDialog() {
  return new Promise((resolve) => {
    pendingResolve = resolve;
    chinaRegionUnsupportedOpen.value = true;
  });
}

/** 关闭地区限制弹窗（确认 / 遮罩 / X） */
export function dismissChinaRegionUnsupportedDialog() {
  chinaRegionUnsupportedOpen.value = false;
  const resolve = pendingResolve;
  pendingResolve = null;
  if (resolve) resolve(false);
}

/**
 * 充值 / 提现前中国大陆出口拦截。
 * 每次点击强制重探（避免 VPN 开关后仍命中旧缓存）。
 * @returns {Promise<boolean>} true 表示可继续打开流程
 */
export async function guardDepositAgainstChinaMainland() {
  const isMainland = await resolveIsChinaMainlandUser({ forceRefresh: true });
  if (!isMainland) return true;
  await openChinaRegionUnsupportedDialog();
  return false;
}
